// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__17bTq","HideInDesktop":"SideDrawer_HideInDesktop__1S96H","Open":"SideDrawer_Open__1tiAm","Close":"SideDrawer_Close__WsOH9"};